export const ALL_PAYMENT_METHOD_NAME = 'ALL';
export const CREDIT_CARD_ERROR_TYPE = 'CREDIT_CARD';
export const DEBIT_CARD_ERROR_TYPE = 'DEBIT_CARD';
export const BANKDOWN_ERR_MSG_STATE = {
  DISABLE: 0,
  WARNING: 1
};

export const PAYMENT_TYPES = {
  LOAN: 1,
  CASH: 2,
  CARD: 3,
  PAY_IN_PARTS: 4,
  WALLETS: 5,
  NET_BANKING: 6,
  UPI: 7,
  EMI: 8,
  SELECTED_UPI: 9
};

export const paymentMethodNames = [
  {
    type: PAYMENT_TYPES.CARD,
    payment_method: 'Card'
  },
  {
    type: PAYMENT_TYPES.NET_BANKING,
    payment_method: 'NB'
  },
  {
    type: PAYMENT_TYPES.UPI,
    payment_method: 'UPI'
  },
  {
    type: PAYMENT_TYPES.WALLETS,
    payment_method: 'WALLET'
  },
  {
    type: PAYMENT_TYPES.CASH,
    payment_method: 'Cash'
  }
];

export const paymentGatewayTypes = {
  2: 'Juspay',
  5: 'Ebanx',
  6: 'Propelld',
  7: 'Eduvanz',
  8: 'Isure',
  9: 'Zestmoney'
};

export const STORE_PROCESSOR = 'StoreBased';

export const REFERRAL_SUGGESTIONS_EXP = 'recommended_referral_code';

export const STORESUBSCRIPTION_PROCESSOR = 'StoreSubscriptionBased';

export const STOREBUNDLE_PROCESSOR = 'StoreBundle';

export const PaymentMethodLabel = {
  [PAYMENT_TYPES.UPI]: 'Add your UPI ID',
  [PAYMENT_TYPES.NET_BANKING]: 'Select your bank',
  [PAYMENT_TYPES.CARD]: 'Add your card details',
  [PAYMENT_TYPES.LOAN]: 'No-cost loan'
};

export const isAppRedirectedKey = 'app';
export const UPI_QR = 'UPI_QR';
export const UPI_Intent = 'UPI_Intent';

export const LOAN_VIEWS = {
  PRE_APPROVED_LOAN: 'PRE_APPROVED_LOAN',
  NO_COST_LOAN: 'NO_COST_LOAN'
};

export const PRE_APPROVED_LOAN_PAYMENT_GATEWAY = 'SHOPSE';
export const PRE_APPROVED_LOAN_PAYMENT_TYPE = 'CONSUMER_FINANCE';
export const PRE_APPROVED_LOAN_EMI_TYPE = 'NO_COST_EMI';
